export const CheckoutErrorException = function(type, code, message) {
  this.type = type
  this.code = code
  this.message = message
  this.name = 'CheckoutErrorException'
}
